import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4d155e3f"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d155e3f')) {
      api.createRecord('4d155e3f', component.options)
    } else {
      api.reload('4d155e3f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4d155e3f", function () {
      api.rerender('4d155e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LeadSources/index.vue"
export default component.exports